/* Yonwold interactive theme behaviours - v1
   Compare Lab slider + hotspots, size selector sync, mobile sticky ATC.
   Vanilla JS, no dependencies. Loaded at the end of <body>. */

(function () {
  'use strict';
  var REDUCED_MOTION = false;
  try { REDUCED_MOTION = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  function ywActiveImg(root) {
    root = root || document;
    var a = root.querySelector('.productView-image-wrapper .slick-active img[data-main-image], .productView-image-wrapper .is-active img[data-main-image]');
    if (a) return a;
    var all = root.querySelectorAll('.productView-image-wrapper img[data-main-image]');
    for (var i = 0; i < all.length; i++) { if (all[i].offsetParent !== null) return all[i]; }
    return all[0] || null;
  }
  function ywPopAnim(el) {
    if (!el || !el.animate || REDUCED_MOTION) return;
    el.classList.remove('yw-pill-pick'); void el.offsetWidth; el.classList.add('yw-pill-pick');
    el.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.06)' }, { transform: 'scale(1)' }], { duration: 320, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
  }
  function ywPulseAnim(el) {
    if (!el || !el.animate || REDUCED_MOTION) return;
    el.animate([{ opacity: 0.35, transform: 'scale(0.97)' }, { opacity: 1, transform: 'scale(1)' }], { duration: 320, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
  }
  function ywPopPrice() {
    var p = document.querySelector('.productView-price');
    if (!p) return;
    ywPulseAnim(p);
    var mainPill = document.querySelector('variant-radios input[type="radio"]:checked');
    if (mainPill) {
      var lbl = mainPill.closest('label');
      if (lbl) ywPopAnim(lbl);
    }
  }

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); } else { document.addEventListener('DOMContentLoaded', fn); }
  }

  /* ---------------- Compare Lab ---------------- */
  function initCompare(lab) {
    var stage = lab.querySelector('[data-yw-stage]');
    var media = lab.querySelector('[data-yw-media]');
    var range = lab.querySelector('[data-yw-range]');
    var after = lab.querySelector('[data-yw-img-after]');
    var afterWrap = lab.querySelector('[data-yw-after]');
    var divider = lab.querySelector('[data-yw-divider]');
    var hotspots = lab.querySelectorAll('[data-yw-hotspot]');
    if (!range || !afterWrap || !divider) return;

    // Keep the stage ratio driven by the first image that loads
    var beforeImg = lab.querySelector('[data-yw-img-before]');
    function fitStage() {
      var img = beforeImg && beforeImg.complete && beforeImg.naturalWidth ? beforeImg : after;
      if (img && img.naturalWidth) {
        var ratio = img.naturalWidth / img.naturalHeight;
        if (isFinite(ratio) && ratio > 0) {
          media.style.aspectRatio = ratio.toFixed(4);
          media.style.removeProperty('aspect-ratio');
          media.style.aspectRatio = ratio.toFixed(4);
        }
      }
    }
    if (beforeImg) {
      if (beforeImg.complete) { fitStage(); } else { beforeImg.addEventListener('load', fitStage); }
    }
    if (after && after.addEventListener) { after.addEventListener('load', fitStage); }

    function setPos(val) {
      var v = Math.max(0, Math.min(100, Number(val) || 50));
      range.value = v;
      afterWrap.style.clipPath = 'inset(0 0 0 ' + v + '%)';
      divider.style.left = v + '%';
    }

    range.addEventListener('input', function () { setPos(range.value); });
  range.addEventListener('change', function () { lab.classList.add('yw-compare__hint-hidden'); });

    // Pointer drag on the media area
    var dragging = false;
    media.addEventListener('pointerdown', function (e) {
      dragging = true;
      media.setPointerCapture && media.setPointerCapture(e.pointerId);
      moveTo(e);
      lab.classList.add('yw-compare__dragging', 'yw-compare__hint-hidden');
    });
    media.addEventListener('pointermove', function (e) {
      if (dragging) moveTo(e);
    });
    function endDrag() { dragging = false; lab.classList.remove('yw-compare__dragging'); }
    media.addEventListener('pointerup', endDrag);
    media.addEventListener('pointercancel', endDrag);

    function moveTo(e) {
      var rect = media.getBoundingClientRect();
      if (!rect.width) return;
      var x = e.clientX - rect.left;
      setPos((x / rect.width) * 100);
    }

    // Hotspot toggle (click), close others
    hotspots.forEach(function (hot) {
      hot.addEventListener('click', function (ev) {
        ev.stopPropagation();
        var open = hot.getAttribute('aria-expanded') === 'true';
        hotspots.forEach(function (h) { h.setAttribute('aria-expanded', 'false'); });
        hot.setAttribute('aria-expanded', open ? 'false' : 'true');
      });
    });

    setPos(50);
  }

  /* ---------------- Size selector ---------------- */
  function initSizeSelector(root) {
    var productId = root.getAttribute('data-product-id');
    var sizePosition = parseInt(root.getAttribute('data-size-position') || '1', 10);
    var pills = root.querySelectorAll('[data-yw-size-pill]');
    var readoutPrice = root.querySelector('[data-yw-readout-price]');
    var readoutStatus = root.querySelector('[data-yw-readout-status]');
    var activePill = null;
    if (!pills.length) return;

    function mainForm() {
      var form = document.getElementById('product-form-' + productId);
      if (form) return form;
      var cand = document.querySelector('form[action*="/cart/add"] input[name="id"]');
      return cand ? cand.closest('form') : null;
    }

    function mainPriceElement() {
      return document.getElementById('product-price-' + productId);
    }

    function updateMainPrice(v) {
      var priceEl = mainPriceElement();
      if (!priceEl || !v) return;
      var reg = priceEl.querySelector('.price-item--regular');
      if (reg && v.price) reg.textContent = formatMoney(v.price);
      var sale = priceEl.querySelector('.price-item--sale');
      if (sale) {
        if (v.compare_at_price) sale.textContent = formatMoney(v.compare_at_price);
      }
    }

    // Move the selector into the product info column: directly after the price
    // block, which sits below title/price and above the variant picker / buy buttons.
    function relocateIntoInfoColumn() {
      var priceEl = mainPriceElement();
      if (!priceEl) return false;
      var anchor = priceEl.closest('.productView-moreItem') || priceEl.parentElement;
      if (!anchor || !anchor.parentNode) return false;
      if (anchor.nextSibling !== root) {
        anchor.parentNode.insertBefore(root, anchor.nextSibling);
      }
      return true;
    }

    function variantsJSON() {
      var script = document.querySelector('variant-radios script');
      if (!script) return [];
      try {
        var txt = script.textContent.trim();
        return txt.charAt(0) === '[' ? JSON.parse(txt) : [];
      } catch (e) { return []; }
    }

    function optionValueOf(v, pos) {
      if (pos === 1) return v.option1;
      if (pos === 2) return v.option2;
      if (pos === 3) return v.option3;
      return null;
    }

    function sizeFieldset() {
      var vr = document.querySelector('variant-radios');
      if (!vr) return null;
      var fsets = vr.querySelectorAll('fieldset');
      for (var i = 0; i < fsets.length; i++) {
        if (parseInt(fsets[i].getAttribute('data-option-index'), 10) === sizePosition - 1) return fsets[i];
      }
      return null;
    }

    // Current selections for every non-size dimension (adapter, color, ...)
    function currentSelections() {
      var sel = {};
      var vr = document.querySelector('variant-radios');
      if (!vr) return sel;
      var fsets = vr.querySelectorAll('fieldset');
      for (var i = 0; i < fsets.length; i++) {
        var idx = parseInt(fsets[i].getAttribute('data-option-index'), 10);
        if (isNaN(idx) || idx === sizePosition - 1) continue;
        var checked = fsets[i].querySelector('input[type="radio"]:checked');
        if (checked) sel[idx + 1] = checked.value;
      }
      return sel;
    }

    // Prefers the exact combination (size + currently selected adapter/color),
    // falling back to the same size (prefer available, then same color, then USA).
    function pickForSize(size) {
      var variants = variantsJSON();
      var sel = currentSelections();
      var exact = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (optionValueOf(v, sizePosition) !== size) continue;
        var match = true;
        for (var p in sel) {
          if (optionValueOf(v, parseInt(p, 10)) !== sel[p]) { match = false; break; }
        }
        if (match) { exact = v; break; }
      }
      if (exact) return exact;
      var cands = variants.filter(function (x) { return optionValueOf(x, sizePosition) === size; });
      if (!cands.length) return null;
      var avail = cands.filter(function (x) { return x.available; });
      var pool = avail.length ? avail : cands;
      var otherPos = null;
      for (var p2 in sel) { var pp = parseInt(p2, 10); if (pp !== sizePosition) { otherPos = pp; break; } }
      if (otherPos) {
        var sameOther = pool.filter(function (x) { return optionValueOf(x, otherPos) === sel[otherPos]; });
        if (sameOther.length) return sameOther[0];
      }
      var usa = pool.filter(function (x) { return (x.title || '').indexOf('USA') !== -1; });
      return usa[0] || pool[0];
    }

    function applyVariant(v, size, sizeAvail) {
      var form = mainForm();
      if (v) {
        // Keep the hidden Size fieldset in sync so the theme's own variant logic stays consistent
        var fs = sizeFieldset();
        if (fs) {
          var radios = fs.querySelectorAll('input[type="radio"]');
          for (var i = 0; i < radios.length; i++) {
            if (radios[i].value === size && !radios[i].checked) {
              radios[i].checked = true;
              radios[i].dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }
          }
        }
        // Final authority: the hidden id input drives add-to-cart
        if (form) {
          var idInput = form.querySelector('input[name="id"]');
          if (idInput) idInput.value = String(v.id);
        }
        var select = document.querySelector('select[name="id"]');
        if (select) {
          var match = Array.prototype.slice.call(select.options).find(function (o) { return o.value === String(v.id); });
          if (match) { select.value = match.value; select.dispatchEvent(new Event('change', { bubbles: true })); }
        }
        var inStock = sizeAvail && v.available;
        if (readoutPrice) readoutPrice.textContent = formatMoney(v.price);
        if (readoutStatus) {
          readoutStatus.textContent = inStock ? 'In stock' : 'Out of stock';
          readoutStatus.classList.toggle('is-oos', !inStock);
        }
        updateMainPrice(v);
        updateStickyPrice(v.price, v.available);
      updateStickyName(v.title);
        var btn = document.getElementById('product-add-to-cart');
        if (btn) { btn.disabled = !v.available; }
      }
    }

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        pills.forEach(function (p) { p.classList.remove('is-active'); });
        pill.classList.add('is-active');
        activePill = pill;
        var size = pill.getAttribute('data-size');
        var v = pickForSize(size);
        var avail = pill.getAttribute('data-available') === 'true';
        applyVariant(v, size, avail);
      });
    });

    // When the merchant changes adapter/color in the default picker, keep the
    // readout, main price and sticky price in sync with the active size.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('variant-radios input[type="radio"]') && activePill) {
        var v = pickForSize(activePill.getAttribute('data-size'));
        if (v) {
          if (readoutPrice) readoutPrice.textContent = formatMoney(v.price);
          if (readoutStatus) {
            readoutStatus.textContent = v.available ? 'In stock' : 'Out of stock';
            readoutStatus.classList.toggle('is-oos', !v.available);
          }
          updateMainPrice(v);
          updateStickyPrice(v.price, v.available);
      updateStickyName(v.title);
          var btn = document.getElementById('product-add-to-cart');
          if (btn) { btn.disabled = !v.available; }
        }
      }
    });

    // Place the selector inside the product info column (below price, above
    // variant picker / buy buttons), then reveal it.
    relocateIntoInfoColumn();
    root.style.display = 'block';

    // Pre-select the first in-stock pill so the readout is not empty
    var firstAvail = Array.prototype.slice.call(pills).find(function (p) { return p.getAttribute('data-available') === 'true'; });
    (firstAvail || pills[0]).click();
  }

  function formatMoney(cents) {
    var n = Number(cents) / 100;
    if (!isFinite(n)) return '';
    return '$' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  /* ---------------- Sticky ATC ---------------- */
  var stickyPriceEl = null;

  function updateStickyPrice(cents, avail) {
    if (!stickyPriceEl) {
      stickyPriceEl = document.querySelector('[data-yw-sticky-price]');
    }
    if (stickyPriceEl && cents) stickyPriceEl.textContent = formatMoney(cents);
  }

  var stickyNameEl = null;
  var stickyThumbImg = null;
  function updateStickyName(title) {
    if (!stickyNameEl) stickyNameEl = document.querySelector('[data-yw-sticky-name]');
    if (stickyNameEl && title) stickyNameEl.textContent = title;
  }
  function updateStickyThumb(src) {
    if (!stickyThumbImg) stickyThumbImg = document.querySelector('[data-yw-sticky-thumb]');
    if (stickyThumbImg && src) stickyThumbImg.src = src;
  }

  function initSticky(sticky) {
    var productId = sticky.getAttribute('data-product-id');
    var addBtn = sticky.querySelector('[data-yw-sticky-add]');
    var mainSubmit = document.getElementById('product-add-to-cart');
    stickyPriceEl = sticky.querySelector('[data-yw-sticky-price]');

    function show() { sticky.hidden = false; }
    function hide() { sticky.hidden = true; }

    function maybeShow() {
      if (window.scrollY < 420) { hide(); return; }
      if (mainSubmit) {
        var r = mainSubmit.getBoundingClientRect();
        if (r.top > -40 && r.bottom < window.innerHeight + 40) { hide(); return; }
      }
      show();
    }

    window.addEventListener('scroll', maybeShow, { passive: true });
    window.addEventListener('resize', maybeShow);
    maybeShow();

    addBtn.addEventListener('click', function () {
      var form = document.getElementById('product-form-' + productId);
      if (!form) {
        var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
        form = idInput ? idInput.closest('form') : null;
      }
      if (form) {
        if (typeof form.requestSubmit === 'function') { form.requestSubmit(); } else { form.submit(); }
      } else if (mainSubmit) {
        mainSubmit.click();
      }
    });
  }

  /* ---------------- Boot ---------------- */
  ready(function () {
    document.querySelectorAll('[data-yw-compare]').forEach(initCompare);
    document.querySelectorAll('[data-yw-size]').forEach(initSizeSelector);
    document.querySelectorAll('[data-yw-sticky]').forEach(initSticky);
    initGallery();
    initStickyThumbSync();
    initThumbnailPreview();
    initVariantPillFeedback();
    initTabsTransition();
  });
  /* ---------------- Sticky thumb sync (D3) ---------------- */
  function initStickyThumbSync() {
    var sticky = document.querySelector('[data-yw-sticky]');
    if (!sticky) return;
    var thumb = sticky.querySelector('[data-yw-sticky-thumb]');
    if (!thumb) return;
    // Watch the main gallery image for src changes (slick slider re-renders).
    var mainNav = document.querySelector('[data-image-gallery-main]');
    if (!mainNav) return;
    var lastSrc = '';
    function check() {
      var active = mainNav.querySelector('.slick-active img[data-main-image], .is-active img[data-main-image]');
      if (!active) {
        var all = mainNav.querySelectorAll('img[data-main-image]');
        for (var i = 0; i < all.length; i++) { if (all[i].offsetParent !== null) { active = all[i]; break; } }
        if (!active) active = all[0];
      }
      if (!active) return;
      var s = active.currentSrc || active.src || active.getAttribute('data-src') || '';
      if (s && s !== lastSrc) { lastSrc = s; thumb.src = s; }
    }
    // Poll every 400ms (cheap: one querySelector + one src read, no layout).
    // MutationObserver on slick's DOM churn is unreliable across versions;
    // a low-rate poll is the robust progressive-enhancement approach.
    var timer = setInterval(check, 400);
    check();
    // Stop polling after 60s (sticky bar is only relevant for a while).
    setTimeout(function () { clearInterval(timer); }, 60000);
  }

  /* ---------------- Gallery (L3) ---------------- */
  function initGallery() {
    var wrapper = document.querySelector('.productView-image-wrapper');
    if (!wrapper) return;

    // Crossfade: when the visible main image changes, play a brief opacity
    // fade-in on the incoming image. Uses the Web Animations API (compositor,
    // no reflow, replays cleanly on every change). Respects reduced-motion.
    var lastVisible = null;
    var mo = new MutationObserver(function () {
      var active = ywActiveImg(wrapper);
      if (!active || REDUCED_MOTION) return;
      if (lastVisible && active !== lastVisible) {
        if (active.animate) active.animate([{ opacity: 0.3 }, { opacity: 1 }], { duration: 250, easing: 'ease' });
      }
      lastVisible = active;
    });
    mo.observe(wrapper, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    // Lightbox: click on the main image opens an overlay.
    wrapper.addEventListener('click', function (e) {
      if (e.target.tagName !== 'IMG') return;
      // Don't open lightbox if the user is clicking on a thumbnail (those are
      // in a separate container outside .productView-image-wrapper).
      var src = e.target.currentSrc || e.target.src || e.target.getAttribute('data-src');
      if (src) openLightbox(src);
    });
  }


  /* ---------------- Thumbnail hover preview (L3) ---------------- */
  function initThumbnailPreview() {
    var wrapper = document.querySelector('.productView-image-wrapper');
    if (!wrapper) return;
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('.productView-thumbnail-link[data-image]'));
    if (!thumbs.length) return;
    var layer = document.createElement('div');
    layer.className = 'yw-thum-preview';
    var img = document.createElement('img');
    img.alt = '';
    layer.appendChild(img);
    wrapper.appendChild(layer);
    var activeUrl = function () {
      var a = ywActiveImg(wrapper);
      return a ? (a.currentSrc || a.src || '') : '';
    };
    function setPreview(url) {
      if (!url || url === activeUrl()) { layer.classList.remove('is-on'); return; }
      img.src = url;
      layer.classList.add('is-on');
    }
    thumbs.forEach(function (th) {
      th.addEventListener('mouseenter', function () {
        if (document.querySelector('.yw-lightbox')) return; // lightbox open -> skip
        setPreview(th.getAttribute('data-image'));
      });
      th.addEventListener('mouseleave', function () { layer.classList.remove('is-on'); });
    });
  }

  /* ---------------- Variant pill + price feedback (L3) ---------------- */
  function initVariantPillFeedback() {
    var sizeRoot = document.querySelector('[data-yw-size]');
    if (sizeRoot) {
      var pills = sizeRoot.querySelectorAll('[data-yw-size-pill]');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.classList.remove('yw-pill-pick'); });
          ywPopAnim(pill);
          var rp = sizeRoot.querySelector('[data-yw-readout-price]');
          ywPulseAnim(rp);
        });
      });
    }
    // Plug / adapter / color picked in the native variant picker: pop the
    // checked pill + pulse the price. No second variant state machine — we
    // only add a transient animation class; selection logic is untouched.
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (t && t.matches && t.matches('variant-radios input[type="radio"]:checked')) {
        ywPopPrice();
      }
    });
  }

  /* ---------------- Tabs animated height/opacity (L3) ---------------- */
  function initTabsTransition() {
    if (REDUCED_MOTION) return;
    // 1. Horizontal tab panel entrance (opacity/transform) when it becomes active.
    var horiz = document.querySelector('.tabs-contents-horizontal');
    if (horiz) {
      var seen = new WeakSet();
      new MutationObserver(function (muts) {
        muts.forEach(function (mu) {
          if (mu.type === 'attributes' && mu.attributeName === 'class') {
            var el = mu.target;
            if (el.classList && el.classList.contains('is-active') && !seen.has(el)) {
              seen.add(el);
              if (el.animate) el.animate([{ opacity: 0, transform: 'translate3d(0, 10px, 0)' }, { opacity: 1, transform: 'translate3d(0,0,0)' }], { duration: 320, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
            }
          }
        });
      }).observe(horiz, { subtree: true, attributes: true, attributeFilter: ['class'] });
    }
    // 2. Accordion (toggle-content) animated height on open/close.
    var contents = document.querySelectorAll('.toggle-content');
    contents.forEach(function (tc) {
      var prevOpen = tc.classList.contains('is-active') || tc.classList.contains('is-open');
      new MutationObserver(function () {
        var open = tc.classList.contains('is-active') || tc.classList.contains('is-open');
        if (open === prevOpen) return;
        prevOpen = open;
        if (!tc.animate) return;
        var first = tc.firstElementChild;
        var h = first ? first.getBoundingClientRect().height : 0;
        if (open) {
          tc.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
        } else {
          tc.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 240, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' });
        }
      }).observe(tc, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* ---------------- Lightbox (L3) ---------------- */
  function openLightbox(src) {
    if (document.querySelector('.yw-lightbox')) return; // already open
    var el = document.createElement('div');
    el.className = 'yw-lightbox';
    el.setAttribute('role', 'dialog');
    el.setAttribute('aria-modal', 'true');
    el.setAttribute('aria-label', 'Image viewer');
    // Count images for nav (use all main images, not just visible ones).
    var imgs = Array.prototype.slice
      .call(document.querySelectorAll('[data-image-gallery-main] img[data-main-image]'))
      .map(function (im) { return im.currentSrc || im.src || im.getAttribute('data-src') || ''; })
      .filter(Boolean);
    var idx = Math.max(0, imgs.indexOf(src));
    el.innerHTML =
      '<img class="yw-lightbox__img" src="' + src.replace(/"/g, '&quot;') + '" alt="">' +
      '<button class="yw-lightbox__close" data-yw-lb-close aria-label="Close image viewer">&times;</button>' +
      (imgs.length > 1
        ? '<button class="yw-lightbox__nav yw-lightbox__nav--prev" data-yw-lb-prev aria-label="Previous image">&#8592;</button>' +
          '<button class="yw-lightbox__nav yw-lightbox__nav--next" data-yw-lb-next aria-label="Next image">&#8594;</button>'
        : '');
    document.body.appendChild(el);
    el.querySelector('[data-yw-lb-close]').addEventListener('click', closeLightbox);
    var prev = el.querySelector('[data-yw-lb-prev]');
    var next = el.querySelector('[data-yw-lb-next]');
    if (prev) prev.addEventListener('click', function () { lbNav(-1); });
    if (next) next.addEventListener('click', function () { lbNav(1); });
    el.addEventListener('click', function (e) { if (e.target === el) closeLightbox(); });
    document.addEventListener('keydown', lbKey);
    var img = el.querySelector('.yw-lightbox__img');
    img.setAttribute('tabindex', '-1');
    img.focus();
  }
  function lbNav(dir) {
    var imgs = Array.prototype.slice
      .call(document.querySelectorAll('[data-image-gallery-main] img[data-main-image]'))
      .map(function (im) { return im.currentSrc || im.src || im.getAttribute('data-src') || ''; })
      .filter(Boolean);
    if (!imgs.length) return;
    var el = document.querySelector('.yw-lightbox');
    if (!el) return;
    var cur = el.querySelector('.yw-lightbox__img').src;
    var i = Math.max(0, imgs.indexOf(cur));
    i = (i + dir + imgs.length) % imgs.length;
    el.querySelector('.yw-lightbox__img').src = imgs[i];
  }
  function closeLightbox() {
    var el = document.querySelector('.yw-lightbox');
    if (el) el.remove();
    document.removeEventListener('keydown', lbKey);
    var mainImg = document.querySelector('.productView-image-wrapper img[data-main-image]');
    if (mainImg) mainImg.focus();
  }
  function lbKey(e) {
    if (e.key === 'Escape') closeLightbox();
    else if (e.key === 'ArrowRight') lbNav(1);
    else if (e.key === 'ArrowLeft') lbNav(-1);
  }

})();
